import axios from 'axios';
import { getAccessToken } from '../../utility/cookieStorage';

const API_ENDPOINT = process.env.VUE_APP_API_ENDPOINT;

const authHeader = () => ({
  'Authorization': `Bearer ${getAccessToken()}`,
});

const client = axios.create({
  baseURL: API_ENDPOINT,
  headers: {
    'Authorization': `Bearer ${getAccessToken()}`,
    'Content-Type': 'application/json',
  },
  withCredentials: true
});

class DataService {
  static get(path = '') {
    return client({
      method: 'GET',
      url: path,
      headers: { ...authHeader() },
    });
  }

  static post(path = '', data = {}, optionalHeader = {}) {
    return client({
        method: 'POST',
        url: path,
        data,
        headers: { ...authHeader(), ...optionalHeader },
    });
  }

  /**
   * Envio de formularios con archivo. NO se fija el Content-Type a proposito:
   * el navegador tiene que ponerlo el mismo junto con el 'boundary', o el
   * servidor no sabe separar las partes y el archivo no llega.
   */
  static postForm(path = '', formData) {
    return client({
      method: 'POST',
      url: path,
      data: formData,
      headers: { ...authHeader(), 'Content-Type': undefined },
    });
  }

  static patch(path = '', data = {}) {
    return client({
        method: 'PATCH',
        url: path,
        data: JSON.stringify(data),
        headers: { ...authHeader() },
    });
  }

  static delete(path = '', data = {}) {
    return client({
        method: 'DELETE',
        url: path,
        data: JSON.stringify(data),
        headers: { ...authHeader() },
    });
  }

  static put(path = '', data = {}) {
    return client({
      method: 'PUT',
      url: path,
      data: data,
      headers: { ...authHeader() },
    });
  }
}

/**
 * axios interceptors runs before and after a request, letting the developer modify req,req more
 * For more details on axios interceptor see https://github.com/axios/axios#interceptors
 */
client.interceptors.request.use((config) => {
  // do something before executing the request
  // For example tag along the bearer access token to request header or set a cookie
  const requestConfig = config;
  const { headers } = config;
  requestConfig.headers = { ...headers, Authorization: `Bearer ${getAccessToken()}` };

  return requestConfig;
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    /**
     * Do something in case the response returns an error code [3**, 4**, 5**] etc
     * For example, on token expiration retrieve a new access token, retry a failed request etc
     */
    const { response } = error;
    //const originalRequest = error.config;
    
    if (response) {
      switch (response.status) {
        case 401:
          // Handle unauthorized error, e.g., redirect to login or refresh token
          console.error('Unauthorized: Please log in again.');
          break;

        case 403:
          // Handle forbidden error, e.g., user doesn't have permissions
          console.error('Forbidden: You do not have access to this resource.');
          break;

        case 422:
          // Laravel validation errors (usually comes with 'errors' object)
          if (response.data && response.data.errors) {
            const validationErrors = response.data.errors;
            //console.error('Validation Error:', validationErrors);
            // catch first validation error message
            const firstError = Object.values(validationErrors)[0][0];
            console.error('Validation Error:', firstError);
            return Promise.reject({
              message: 'Validation failed',
              errors: validationErrors,
            });
          }
          break;

        case 500:
          // Handle server error
          console.error('Server Error: Something went wrong on the server.');
          break;

        default:
          // Handle other errors
          //console.error(`Error: ${response.status} - ${response.statusText}`);

          if (response.data && response.data.message) {
            return Promise.reject({
              message: response.data.message,
            });
          }
      }
    } else {
      console.error("No response from server.");
    }

    return Promise.reject(error);
  },
);

export { DataService };